var _path, _path2, _path3, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 41C1 63.0914 18.9086 81 41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41ZM79 41C79 61.9868 61.9868 79 41 79C20.0132 79 3 61.9868 3 41C3 20.0132 20.0132 3 41 3C61.9868 3 79 20.0132 79 41Z",
    fill: "#FCA66C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1687 23.4547C20.5595 22.5277 20.6852 21.3004 21.4695 20.516C22.2539 19.7317 23.4812 19.606 24.4082 20.2152L44.6576 33.5219C45.7982 34.2715 46.7733 35.2466 47.5228 36.3872L60.8296 56.6366C61.4387 57.5636 61.3131 58.7909 60.5287 59.5753C59.7444 60.3596 58.517 60.4852 57.5901 59.8761L37.3407 46.5694C36.2001 45.8198 35.225 44.8447 34.4754 43.7041L21.1687 23.4547Z",
    fill: "#FCA66C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6015 26.9072L44.6576 33.5155C45.7982 34.265 46.7733 35.2401 47.5229 36.3807L60.8296 56.6301C61.4388 57.5571 61.3131 58.7844 60.5288 59.5688V59.5688C59.7444 60.3531 58.5171 60.4788 57.5901 59.8696L47.3968 53.1712",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.9528,
    cy: 41.9527,
    r: 2.85714,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    transform: "matrix(-1 0 0 1 81 1)",
    stroke: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTour);
export default __webpack_public_path__ + "static/media/tour.56e70f8c7967840676d3278b354a4e7e.svg";
export { ForwardRef as ReactComponent };